module.exports = __webpack_public_path__ + "static/media/tec2.3b12343c.jpg";